<div class="text-center p-20">
  <i class="fa fa-spinner fa-spin"></i> Loading...
</div>
